import { createClient } from '@supabase/supabase-js'
import { VITE_SUPABASE_URL, VITE_SUPABASE_ANON_KEY } from "@/config/index";

const supabaseUrl = process.env.VUE_APP_VITE_SUPABASE_URL;
const supabaseAnonKey = process.env.VUE_APP_VITE_SUPABASE_ANON_KEY;
export const supabase = createClient(supabaseUrl, supabaseAnonKey)